<!-- 顶部 -->
<template>
  <div class="page_head move" :class="{'to_close':open}">
    <div class="head_box">
      <div class="center_title">
<!--        <img :src="setting.logo">-->
<!--        <span>{{setting.title}}</span>-->
      </div>
      <div class="person_info">
        <div class="language_box">
          <img src="../../assets/img/language_white.svg">
          <el-select v-model="languageId" placeholder="请选择语言" @change="uploadLanguage">
            <el-option
              v-for="item in languageOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="language_box">
          <img src="../../assets/img/region.svg">
          <el-select v-model="region" :placeholder="$t('common.select')+$t('common.region')" @change="uploadRegion">
            <el-option
                v-for="(item,index) in regionOptions"
                :key="item.code"
               :label="`${item.name}${item.ename ? ' ('+item.ename+')' : ''}`"
                :value="item.code">
              </el-option>
          </el-select>
        </div>
        <div class="user_info">
          <div>
            <img :src="resetImageUrl(userInfo.photoUrl)" v-if="userInfo&&userInfo.photoUrl">
            <img src="../../assets/img/admin.jpg" v-else>
          </div>
          <p>
            <span>{{ userInfo ? (userInfo.nickName || userInfo.username || 'admin') :''}}</span>
          </p>
        </div>
        <div class="set">
          <div class="out_box">
            <a @click="dropOut">{{$t('header.outBtn')}}</a>
            <div class="set_tip">
              <a>{{$t('header.setBtn')}}</a>
              <div class="menu_box">
                <a @click="gotoDetail">{{$t('header.changeBtn')}}</a>
                <!-- <a v-if="isShowMfa" @click="updateMfa">{{(hasMfa===1) ? $t('header.closeMfa') : $t('header.openMfa')}}MFA</a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <setMFA v-if="isPop" @listenToChild="listenToSetMfa"/>
  </div>
</template>

<script>
import {setUserLogout} from "../../api/auth";
import {removeToken} from "../../utils/auth";
import {getUser} from "../../utils/user";
import {formatTree, getHorizontalMenu} from "../../utils/menuAuth";
import {mixins} from "../../utils/mixins";
import setMFA from "../setMFA";
import {updateCustomerUserMfa} from "../../api/sys/user";
import {mapActions, mapState} from "vuex";
import { clearBtnAuth } from "../../utils/btnAuth";

export default {
  components:{
    setMFA
  },
  mixins:[mixins],
  props: ['open'],
  data() {
    return {
      isPop: false,
      region: '',
      menuList: []
    }
  },
  computed:{
    defaultConfig() {
      return {
        name: this.$t('title'),
        ename: this.$t('title'),
        iconUrl: require('../../assets/img/aws-logo.png'),
      }
    },
    setting(){
      let info = this.config ? this.config : this.defaultConfig
      return {
        title: this.languageId===1 ? info.name : info.ename,
        logo: info.iconUrl,
      }
    },
    isShowMfa() {
      return this.menuList.some(item => item.name === 'MFA')
    },
    ...mapState(['hasMfa'])
  },
  created() {
    // 获取配置信息
    this.config = (this.$store.state.setting.siteSetting && JSON.stringify(this.$store.state.setting.siteSetting) !== '{}') ? this.$store.state.setting.siteSetting : this.defaultConfig
    let menus = getHorizontalMenu()
    menus = JSON.parse(menus)
    this.menuList = Array.isArray(menus) ? menus :  []
  },
  mounted() {
    if (!getUser()) {
      this.dropOut();
    }
    this.region = this.regionCode
    this.$store.dispatch('updateHasMfaAsync')
  },

  methods: {
    ...mapActions(['updateHasMfaAsync']),
    dropOut() {
      setUserLogout({}).then((res) => {
        removeToken();
        this.$store.commit('SET_MFA',0)
        this.$store.commit('SET_BTN_AUTH', null);
        this.$store.commit('SET_ALL_BTN_AUTH', {});
        clearBtnAuth();
        this.$router.push('/');
      }).catch((e) => {
      })
    },

    gotoDetail(){
      this.$router.push({
        path:'/sys/password',
        query: {
          key:'pws'
        }
      })
    },

    updateMfa(){
      let that = this
      if (this.hasMfa===1) {
        that.$confirm((that.languageId === 1 ? '确认关闭MFA状态？' : 'Close the MFA status ？'), '提示', {
          title: that.languageId === 1 ? '提示' : 'Tip',
          confirmButtonText: that.languageId === 1 ? '确定' : 'confirm',
          cancelButtonText: that.languageId === 1 ? '取消' : 'cancel',
          type: 'warning'
        }).then(() => {
          let data = {
            uniqueCode: '',
          }
          const notify = that.$notify({
            title: that.languageId === 1 ? '提示' : 'Tip',
            message: that.languageId===1?'正在关闭MFA...':'Closing MFA...',
            offset: 100
          });
          updateCustomerUserMfa(JSON.stringify(data)).then(async response => {
            if (response.success) {
              try {
                await that.$store.dispatch('updateHasMfaAsync');
              } catch (e) {
                console.error(e)
              }
              that.$message.success({
                message: that.$t('btn.success'),
                duration: 1000,
                showClose: true
              });
            }
            notify.close();
          }).catch((e) => {
            notify.close();
          });
        }).catch(() => {})
      } else {
        this.isPop = true
      }
    },
    listenToSetMfa(e){
      this.isPop = false
    }
  }
}
</script>

<style scoped>
.page_head {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 60px;
  min-width: 1180px;
  padding: 0 30px 0 0;
  box-sizing: border-box;
  /*background-color: #3970e3;*/
  background: #0e2a65;
  z-index: 1000;
}

.head_box {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.to_close {
  left: 60px;
}

.center_title{
  padding-left: 20px;
}

.center_title span{
  font-weight: 600;
  font-size: 18px;
  margin-left: 10px;
  color: #fff;
}

.center_title img{
  height: 20px;
  /* height: 30px; */
}

.person_info,.center_title {
  display: flex;
  align-items: center;
}

.user_info {
  display: flex;
  align-items: center;
  color: #fff;
  margin-right: 30px;
}

.user_info img {
  width: 35px;
  height: 35px;
  margin-right: 10px;
  border-radius: 100%;
  /*border: 1px solid #111;*/
  object-fit: cover;
}

.set {
  position: relative;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
}


.out_box {
  display: flex;
  align-items: center;
}

.out_box a {
  line-height: 40px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
}

.out_box .set_tip {
  padding-left: 5px;
  margin-left: 4px;
}

.out_box .set_tip::after {
  content: '';
  position: absolute;
  top: 10px;
  left: 0;
  height: 20px;
  width: 1px;
  background: #bbb;
}

.set_tip {
  position: relative;
}

.set_tip:hover div {
  display: block;
}

.set_tip div {
  margin-top: 20px;
  display: none;
  position: absolute;
  right: -20px;
  top: 20px;
  min-width: 100px;
  box-shadow: 2px 2px 4px #868686;
}

.set_tip div a {
  display: block;
  background: #fff;
  line-height: 40px;
  color: #3970e3;
  white-space: nowrap;
  padding:0 10px;
}

.language_box{
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.language_box img{
  width: 20px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/head/index.vue